import React, { useEffect, useState } from 'react';
import {  useSelector } from 'react-redux';
import { Modal,Button } from 'react-bootstrap';
import RadioButton from '../../Common/RadioButton'
import paths from '../../../routes/paths';
import DefaultPagination from '../../Common/Pagination';
import KurtiProduct from './KurtiProduct';
import { Link } from 'react-router-dom';
import SareeProduct from './SareeProduct';

const SellerSarees =() => {
    const {loggedInUser} = useSelector((state:any) => state.auth)
    const [modalShow, setModalShow] = useState(false);
    const handleModalClose = () => setModalShow(false);
    const [selectedProduct, setSelectedProduct] = useState('' as any);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(true); 
    const [products, setProducts] =  useState<any[]>([]); 
  
    
    useEffect(() => {
      fetchAllProducts(currentPage);
    }, [currentPage]);
    

    const handleModalOpen = (product) => {
      setModalShow(true);
      setSelectedProduct(product); 
    }


    
    const fetchAllProducts = async (page) => {
      setLoading(true);
      try {
        const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/v1/products/seller_sarees?seller_id=${loggedInUser.sId}&page=${page}&per_page=40`);
        // Check if the response is OK (status code 200-299)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const data = await response.json(); // Parse the JSON data
        setProducts(data.data);
        setTotalPages(data.total_pages); 
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoading(false);
      }
    };
  
  const handlePageChange = (page) => {
    setCurrentPage(page); 
    window.scrollTo(0, 0)
  };

    console.log("s prod", currentPage,totalPages)
    return (
        <div className="page-content bg-light">
            <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG">
              <div className="container">
                  <div className="dz-bnr-inr-entry">
                  <h1>My Account</h1>
                  <nav aria-label="breadcrumb" className="breadcrumb-row">
                      <ul className="breadcrumb">
                      <li className="breadcrumb-item"><span> Dashboard</span></li>
                      <li className="breadcrumb-item"> Products</li>
                      </ul>
                  </nav>
                  </div>
              </div>	
            </div> 
            
            <div className="content-inner-1"> 
                <div className="row">
                  <section className="col-xl-12 account-wrapper sellerProducts">
                      <div className="account-card">
                      <div className="table-responsive table-style-1">
                        <table className="table table-hover mb-3">
                          {/* <thead>
                            <tr>
                              <th>Image</th>
                              <th>Product</th>
                              <th>Price</th>
                              <th></th>
                              <th>Sold Amount</th>
                              <th>Settelment</th>
                              <th></th> 
                            </tr>
                          </thead> */}
                          <tbody>
                            {products?.map((product,index) => 
                              <tr key={index}> 
                                <td>{ <img src={process.env.REACT_APP_SERVER_URL + ( product.variants[0].variant_images[0]?.display_image_url)} alt="product" className='sellerProductsImage'/>}</td>

                                {product.subcategory.name === "Sarees" ? <SareeProduct product={product} /> :  <KurtiProduct product={product}/>}   
                                <td>
                                    <button className="btn btn-secondary btn-sm" onClick={() => handleModalOpen(product)}>View</button> &nbsp;<Link to={paths.productDetails(product.id)}  target="_blank" className="btn btn-primary btn-sm">Link</Link>
                                  </td>
                              </tr>
                            )}
                          
                          </tbody>
                        </table>
                      </div>
                      {loading ? (''
                      ) : (
                    <div className="row page mt-0">
                      <div className="col-md-6">
                        <p className="page-text">Showing page {currentPage} Of {totalPages} Pages</p>
                      </div>
                      <div className="col-md-6">
                    
                        <DefaultPagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={handlePageChange}
                        />
                        {products.length === 0 &&  
                          <div className="col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 m-md-b15 m-b30">
                              <div className="shop-card style-1">No Products.</div>
                          </div>
                        }
                      </div> 
                    </div>
                  )}
                      </div>
                  </section>
                 
                  </div>
            </div>
            <Modal size="xl" show={modalShow} onHide={handleModalClose}>
                            
                  <Modal.Header closeButton>
                      <Modal.Title>Product Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="mb-3 p-a20 sellerProducts">
                        <div className="col-xl-12"> 
                          <section className="col-xl-9 account-wrapper">
                            <div className="account-card order-details">
                              <div className="order-head">
                                <div className={"head-thumb tshirtImage bG"  }>
                                  <img src={process.env.REACT_APP_SERVER_URL + (selectedProduct && (selectedProduct.variants[0]?.variant_images[0]?.display_image_url))} alt="variant"/>
                                </div>
                                <div className="clearfix m-l20">
                                  <div className={"badge pending" }>{selectedProduct?.subcategory?.name + ' > ' }
                                  {selectedProduct?.sub_subcategory?.name  }</div>
                                  <h4 className="mb-0">{selectedProduct?.name}</h4>
                                  {/* <p>{selectedProduct?.subcategory?.name + ' > ' }
                                      {selectedProduct?.sub_subcategory?.name  }</p> */}
                                  <p>{selectedProduct?.description  }</p>
                                </div>
                              </div>
                              <div className="row mb-sm-4 mb-2">
                                <div className="table-responsive table-style-1">
                                  <table className="table table-hover mb-3">
                                    <thead>
                                      <tr>
                                        <th>SKU</th>
                                        <th>Price</th>
                                        <th></th>
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {selectedProduct?.variants?.map((variant,index) => 
                                        <tr key={index}> 
                                          
                                          <td className='title'>  {variant.sku}   </td>
                                          <td> <h5 className="price">₹{Math.round(variant.price)} <span className='strikedPrice'>₹{Math.round(variant.actual_price)}</span></h5> </td>

                                          <td>  
                                            {selectedProduct.subcategory?.name !== "Sarees" && (
                                              <div className="btn-group product-size m-b-10">
                                                {variant.out_of_stock && <div className='btn disable-btn'>{variant.size}</div>}
                                                {!variant.out_of_stock && <RadioButton key={index} name="SizeSelection" id={"SizeSelection"+index} value={variant.size} label={variant.size}  inputClassName='btn-check' labelClassName="btn" checkedRadio={ ""} selectedRadioValue={(value) => '' } />}
                                              </div>
                                            )}                            
                                            
                                          </td>
                                              
                                          <td>
                                            <span className={ ( variant.out_of_stock ? ' bg-danger ' : ' bg-success ') + " badge  m-0"}>{variant.out_of_stock ?   'Out of Stock' : 'In Stock'}</span>
                                          </td>
                                        </tr>
                                      )}
                                    
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              
                              
                            </div>
                          </section>
                        </div>
                    </div> 
                  </Modal.Body>
                  <Modal.Footer>  
                      <Button variant="secondary" onClick={handleModalClose}>
                          Close
                      </Button>
                  </Modal.Footer> 
                   
                              
            </Modal>
        </div>
             
    )
}

export default SellerSarees;
